import { useCallback, useEffect, useRef } from 'react';

export default function useNotificationTone() {
  const audioContextRef = useRef(null);

  useEffect(() => {
    return () => {
      audioContextRef.current?.close().catch(() => {});
      audioContextRef.current = null;
    };
  }, []);

  return useCallback(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const AudioContextClass = window.AudioContext || window.webkitAudioContext;

    if (!AudioContextClass) {
      return;
    }

    if (!audioContextRef.current) {
      audioContextRef.current = new AudioContextClass();
    }

    const context = audioContextRef.current;
    const now = context.currentTime;
    const gainNode = context.createGain();
    const firstOscillator = context.createOscillator();
    const secondOscillator = context.createOscillator();

    if (context.state === 'suspended') {
      context.resume().catch(() => {});
    }

    gainNode.connect(context.destination);
    gainNode.gain.setValueAtTime(0.0001, now);
    gainNode.gain.exponentialRampToValueAtTime(0.08, now + 0.02);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 0.42);

    firstOscillator.type = 'sine';
    firstOscillator.frequency.setValueAtTime(740, now);
    firstOscillator.frequency.exponentialRampToValueAtTime(880, now + 0.16);

    secondOscillator.type = 'triangle';
    secondOscillator.frequency.setValueAtTime(1100, now + 0.1);
    secondOscillator.frequency.exponentialRampToValueAtTime(1320, now + 0.22);

    firstOscillator.connect(gainNode);
    secondOscillator.connect(gainNode);

    firstOscillator.start(now);
    secondOscillator.start(now + 0.1);
    firstOscillator.stop(now + 0.24);
    secondOscillator.stop(now + 0.42);
  }, []);
}
